import { E_Language } from "@green24/npm-javascript-utils";
import { E_Route } from "./constants/Enum_Routes";

export const M_Application = {
	redirectTimeout: "1m",
	updateWaitTime: "2m",
	defaultLanguage: E_Language.CZECH,
	"return": {url: E_Route.BASE, title: undefined}
};
